import { render } from "./CountsByLocation.vue?vue&type=template&id=4ca9b846"
import script from "./CountsByLocation.vue?vue&type=script&lang=js"
export * from "./CountsByLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__